module.exports = { "default": require("core-js/library/fn/math/hypot"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/core-js/math/hypot.js
// module id = 286
// module chunks = 1